"use client";

// Re-export types
export type { AdvancedFilterGroup, FilterContextValue, FilterContextProviderProps } from "./types";
export type { FilterStableValue, FilterStateValue } from "./contexts";

// Re-export provider
export { FilterContextProvider } from "./FilterContext";

// Re-export hooks
// `useFilterContext` reads BOTH halves (compatibility); the narrow hooks let a
// consumer subscribe to only the half it actually uses. See `contexts.ts`.
export {
  useFilterContext,
  useFilterStable,
  useFilterActions,
  useFilterHelpers,
  useFilterState,
} from "./useFilterContext";
